export default __webpack_public_path__ + "static/media/DK_Layout_3.8b1b279c.png";